// Lib
import { first, last, split } from 'lodash/fp';

// Utils
import { sanitiseFilename } from './filenameUtils';

const splitSlash = split('/');
const splitQuery = split('?');

/** Decodes URL paths so browser download names preserve spaces and Unicode. */
const getFilenameFromUrl = (url: string, fileType = ''): string => {
    const path = (first(splitQuery(url)) as string) ?? '';
    const encodedFilename = (last(splitSlash(path)) as string) ?? '';
    let decodedFilename = encodedFilename;

    try {
        decodedFilename = decodeURIComponent(encodedFilename);
    } catch {
        // Preserve malformed external URLs rather than preventing the download.
    }

    const filename = sanitiseFilename(decodedFilename);

    if (filename.indexOf('.') > -1) return filename;

    const extension = (last(splitSlash(fileType)) as string) ?? '';
    return extension ? `${filename}.${extension}` : filename;
};

export default getFilenameFromUrl;
